export default __webpack_public_path__ + "static/media/nextjs.a725f5cb.png";